import createContextStore, { propType } from './context-store';
export default createContextStore;
export { propType };